export default __webpack_public_path__ + "static/blob4-e5803c4cb40598915202c0f9338fdb3a.svg";